var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AssetType, tenantList, } from './types';
import { deleteUpload, hideUnhide } from '../services/UploadsMetadataService';
import { action, computed, makeObservable, observable, when } from 'mobx';
import { DEFAULT_SHERBERT_BASE_URL, SHERBERT_BASE_URL, SHERBERT_URL, SHERBERT_V3_BASE_URL, } from '../utilities/constants';
import { fetchAssetIdFromSherbertUrl } from '../utilities/common';
import { deleteAsset, getPageImageInfo, getVariantMetadataWithPolling, hideAsset, presignAsset, unhideAsset, AssetStatusType, AssetErrorMessage, isAllowedFormat, Route, getVariantMetadataWithPollingV3, isRoute, getVariantWithPolling, getVariantWithPollingV3, getMultiPageVariant, getMultiPageVariantV3, getImageInfoWithPolling, getAssetInfoV3, getImageInfoV3WithPolling, getImageClassificationInfoV3, getStorageInfoV3, getImageInfoMultipageV3, getColorsInfoV3, getExtractedLogoV3, getFontsV3, getImageTextV3, } from '@design-stack-ct/assets-sdk';
import { assetDataFromUMS } from '../type/assetData';
import { VariantType } from '../type/variantsType';
import { TenantCache } from '../artworkProcessing/TenantCache';
/**
 * An asset object for Vista use cases.
 */
export class VistaAsset {
    constructor(data, assetType, authProvider, signature, callbackFunc) {
        Object.defineProperty(this, "assetType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: { type: AssetStatusType.Unprepared }
        });
        Object.defineProperty(this, "_signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_callbackFunc", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pageImageInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        Object.defineProperty(this, "authProvider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getCroppingParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (left, right, top, bottom) => {
                const isInvalid = [left, right, top, bottom].some((param) => param === null || param === undefined || param < 0 || param >= 1);
                if (isInvalid) {
                    throw new Error('Unsupported args found for cropped');
                }
                if (left && right && left + right >= 1) {
                    throw new Error('Sum of left and right crop values must be less than 1');
                }
                if (top && bottom && top + bottom >= 1) {
                    throw new Error('Sum of top and bottom crop values must be less than 1');
                }
                return `:m=fractions,b=${bottom},l=${left},r=${right},t=${top}`;
            }
        });
        Object.defineProperty(this, "getMonochromeColorParams", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (threshold, color, inverted) => {
                let path = '';
                if (threshold && (threshold > 1 || threshold < 0)) {
                    throw new Error('threshold value must be in between 0 and 1');
                }
                if (threshold) {
                    path += `:t=${threshold}`;
                }
                if (color) {
                    path += threshold ? `,c=${color}` : `:c=${color}`;
                }
                if (inverted !== undefined && inverted !== null) {
                    path += threshold || color ? `,i=${inverted}` : `:i=${inverted}`;
                }
                return path;
            }
        });
        makeObservable(this);
        this.authProvider = authProvider;
        this.assetType = assetType;
        this._data = data;
        this._signature = signature;
        this._callbackFunc = callbackFunc;
        when(() => this.status.type === AssetStatusType.Prepared, () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            try {
                if (!this.isDamAsset()) {
                    if (((_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.image) === null || _c === void 0 ? void 0 : _c.format) !== 'pdf') {
                        const imageInfoUMS = {
                            width: VistaAsset.width(this.data),
                            height: VistaAsset.height(this.data),
                            format: ((_f = (_e = (_d = this.data) === null || _d === void 0 ? void 0 : _d.info) === null || _e === void 0 ? void 0 : _e.image) === null || _f === void 0 ? void 0 : _f.format) || 'unknown',
                            isError: false,
                            // isSupported is unknown here. Hence purposely set it to false
                            isSupported: false,
                        };
                        if (this.data) {
                            // Here we are setting image info for UMS asset
                            this.setAssetData(Object.assign(Object.assign({}, this.data), { info: Object.assign(Object.assign({}, (_g = this.data) === null || _g === void 0 ? void 0 : _g.info), { image: imageInfoUMS }) }));
                        }
                    }
                }
                if ((_h = this.data) === null || _h === void 0 ? void 0 : _h.id) {
                    //this to make change backward compatible,
                    //if callback function is provided we will call (after image info is created in Sherbert Side), otherwise, ignore
                    if (callbackFunc)
                        callbackFunc(this.data.id);
                }
                // Don't set image info if the request fails, but don't throw an error either
                // eslint-disable-next-line no-empty
            }
            catch (_j) { }
        }));
    }
    get data() {
        return this._data;
    }
    setAssetData(assetData) {
        this._data = assetData;
    }
    get print() {
        return new VistaAsset(this._data, AssetType.Print, this.authProvider, this._signature, this._callbackFunc);
    }
    get webPreview() {
        return new VistaAsset(this._data, AssetType.WebPreview, this.authProvider, this._signature, this._callbackFunc);
    }
    get thumbnail() {
        return new VistaAsset(this._data, AssetType.Thumb, this.authProvider, this._signature, this._callbackFunc);
    }
    get embroidery() {
        return new VistaAsset(this._data, AssetType.Embroidery, this.authProvider, this._signature, this._callbackFunc);
    }
    get monochrome() {
        return new VistaAsset(this._data, AssetType.Monochrome, this.authProvider, this._signature, this._callbackFunc);
    }
    get sharpened() {
        return new VistaAsset(this._data, AssetType.Sharpened, this.authProvider, this._signature, this._callbackFunc);
    }
    get imageInfo() {
        return new VistaAsset(this._data, AssetType.ImageInfo, this.authProvider, this._signature, this._callbackFunc);
    }
    get isPresigned() {
        return !this.isDamAsset() || (this.signature !== undefined && this.signature !== '');
    }
    get embroderify() {
        return new VistaAsset(this._data, AssetType.Embroiderify, this.authProvider, this._signature, this._callbackFunc);
    }
    get invertColor() {
        return new VistaAsset(this._data, AssetType.InvertColor, this.authProvider, this._signature, this._callbackFunc);
    }
    get signature() {
        // Using _signature property here to avoid an infinite loop
        // eslint-disable-next-line no-underscore-dangle
        return this._signature;
    }
    //Takes the any type because as of 2022-08-11 the info.image block
    //is no longer part of the Sherbert schema. UMS V2 assets endpoint
    //still puts information there for legacy uploads however. New DAM
    //based assets get their image info from the imageInfo variant.
    //This may change again in the near future so this logic may be short lived
    static width(data) {
        var _a, _b, _c, _d, _e;
        const format = (_b = (_a = data.info) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.format;
        return (_e = (_d = (_c = data.info) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d[format]) === null || _e === void 0 ? void 0 : _e.width;
    }
    static height(data) {
        var _a, _b, _c, _d, _e;
        const format = (_b = (_a = data.info) === null || _a === void 0 ? void 0 : _a.image) === null || _b === void 0 ? void 0 : _b.format;
        return (_e = (_d = (_c = data.info) === null || _c === void 0 ? void 0 : _c.image) === null || _d === void 0 ? void 0 : _d[format]) === null || _e === void 0 ? void 0 : _e.height;
    }
    setSignature(signature) {
        this._signature = signature;
    }
    setStatus(status) {
        this.status = status;
    }
    setErrorStatus(error) {
        if (error instanceof Error) {
            this.setStatus({ type: AssetStatusType.Error, rawError: error });
        }
        else if (typeof error === 'string') {
            this.setStatus({ type: AssetStatusType.Error, rawError: new Error(error) });
        }
        else {
            this.setStatus({ type: AssetStatusType.Error, rawError: new Error('Unknown error') });
        }
    }
    /**
     * Prepares the asset for use by creating or retrieving asset data
     */
    prepare() {
        return __awaiter(this, void 0, void 0, function* () {
            this.setStatus({ type: AssetStatusType.Prepared });
            return Promise.resolve();
        });
    }
    updateProgress(percent) {
        this.setStatus({ type: AssetStatusType.Preparing, uploadProgress: percent });
    }
    /**
     * Presigns this asset by setting its signature to a value with presigned authorization. By default this presigning does not expire.
     * @returns {Promise<void>} Returns an empty Promise object.
     */
    presign() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isDamAsset()) {
                yield this.prepare();
            }
            if (this.signature ||
                this.status.type === AssetStatusType.Deleted ||
                this.status.type === AssetStatusType.Deleting) {
                return Promise.resolve();
            }
            let sig;
            if (this.isDamAsset()) {
                try {
                    const headers = new Headers(yield this.authProvider.getAuthHeaders());
                    // By default, the signature returned here never expires.
                    const result = (yield presignAsset({ path: { id: this._data.id } }, { headers }));
                    if ((result === null || result === void 0 ? void 0 : result.status) === 200) {
                        sig = result.data.signature;
                    }
                    this.setSignature(sig);
                    yield this.prepare();
                }
                catch (error) {
                    throw new Error(AssetErrorMessage.PresignFailed);
                }
                if (!sig) {
                    throw new Error(AssetErrorMessage.EmptySignature);
                }
            }
            return;
        });
    }
    /**
     * cerate variant and return metadata of the asset.
     */
    getVariantMetadata(assetData, variant, route) {
        return __awaiter(this, void 0, void 0, function* () {
            let variantAssetData;
            if (this.isDamAsset()) {
                try {
                    switch (route || Route.V3) {
                        case Route.V2:
                            variantAssetData = (yield getVariantMetadataWithPolling({ path: { id: assetData.id, variant } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) })).data;
                            break;
                        case Route.V3:
                            variantAssetData = (yield getVariantMetadataWithPollingV3({ path: { id: assetData.id, variant } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) })).data;
                            break;
                        default:
                            throw new Error(`${route} is not a valid route`);
                    }
                    return variantAssetData;
                }
                catch (error) {
                    throw new Error('unable to create variant');
                }
            }
            else {
                throw new Error('unable to create variant for UMS assets.');
            }
        });
    }
    /**
     * Return Embroiderify variant of the asset.
     */
    getEmbroiderify() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (!this._data) {
                    throw new Error('cannot find data parent asset');
                }
                const data = yield this.getVariantMetadata(this._data, VariantType.Embroiderify, Route.V3);
                return new VistaAsset(data, AssetType.Embroiderify, this.authProvider, undefined, this._callbackFunc);
            }
            catch (error) {
                throw new Error(`unable to create variant: ${VariantType.Embroiderify}`);
            }
        });
    }
    /**
     * Return image info of the asset.
     */
    getImageInfo(assetId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const imageInfo = (yield getImageInfoWithPolling({ path: { id: assetId } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) })).data;
                return imageInfo;
            }
            catch (error) {
                throw new Error('unable to get image info');
            }
        });
    }
    /**
     * Gets the image text of the asset specified by id
     * @param {GetImageTextParams} param Object holding getFonts parameters for this method call.
     */
    getImageText(param) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            const { data: text } = (yield getImageTextV3({ path: { id: this.data.id }, queryParams: param }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) }));
            return text;
        });
    }
    /**
     * Return print variant of the asset.
     */
    getPrint({ includeSignature = true, route = Route.V3 } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (route && !isRoute(route)) {
                throw new Error(`${route} is not a valid route`);
            }
            const data = yield this.getVariantMetadata(this._data, VariantType.Print, route);
            const imageInfo = yield this.getImageInfo(data.id);
            data.info.image = imageInfo;
            const printAsset = new VistaAsset(data, AssetType.Print, this.authProvider, undefined, this._callbackFunc);
            if (includeSignature) {
                yield printAsset.presign();
            }
            return printAsset;
        });
    }
    /**
     * Return webPreview variant of the asset.
     */
    getWebPreview({ includeSignature = true, route = Route.V3 } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (route && !isRoute(route)) {
                throw new Error(`${route} is not a valid route`);
            }
            const data = yield this.getVariantMetadata(this._data, VariantType.WebPreview, route);
            const imageInfo = yield this.getImageInfo(data.id);
            data.info.image = imageInfo;
            const previewAsset = new VistaAsset(data, AssetType.WebPreview, this.authProvider, undefined, this._callbackFunc);
            if (includeSignature) {
                yield previewAsset.presign();
            }
            return previewAsset;
        });
    }
    /**
     * Return thumb variant of the asset.
     */
    getThumb({ includeSignature = true, route = Route.V3 } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (route && !isRoute(route)) {
                throw new Error(`${route} is not a valid route`);
            }
            const data = yield this.getVariantMetadata(this._data, VariantType.Thumb, route);
            const imageInfo = yield this.getImageInfo(data.id);
            data.info.image = imageInfo;
            const thumbAsset = new VistaAsset(data, AssetType.Thumb, this.authProvider, undefined, this._callbackFunc);
            if (includeSignature) {
                yield thumbAsset.presign();
            }
            return thumbAsset;
        });
    }
    /**
     * Return sharpened variant of the asset.
     */
    getSharpened({ includeSignature = true, route = Route.V3 } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (route && !isRoute(route)) {
                throw new Error(`${route} is not a valid route`);
            }
            const data = yield this.getVariantMetadata(this._data, VariantType.Sharpened, route);
            const imageInfo = yield this.getImageInfo(data.id);
            data.info.image = imageInfo;
            const sharpenedAsset = new VistaAsset(data, AssetType.Sharpened, this.authProvider, undefined, this._callbackFunc);
            if (includeSignature) {
                yield sharpenedAsset.presign();
            }
            return sharpenedAsset;
        });
    }
    /**
     * Return background removed variant of the asset.
     */
    getBackgroundRemoved({ includeSignature = true, route = Route.V3 } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (route && !isRoute(route)) {
                throw new Error(`${route} is not a valid route`);
            }
            const data = yield this.getVariantMetadata(this._data, VariantType.BackgroundRemoved, route);
            const imageInfo = yield this.getImageInfo(data.id);
            data.info.image = imageInfo;
            const backgroundRemovedAsset = new VistaAsset(data, AssetType.BackgroundKnockout, this.authProvider, undefined, this._callbackFunc);
            if (includeSignature) {
                yield backgroundRemovedAsset.presign();
            }
            return backgroundRemovedAsset;
        });
    }
    /**
     * Return Monochrome variant of the asset.
     */
    getMonochrome({ includeSignature = true, route = Route.V3 } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (route && !isRoute(route)) {
                throw new Error(`${route} is not a valid route`);
            }
            const data = yield this.getVariantMetadata(this._data, VariantType.Monochrome, route);
            const imageInfo = yield this.getImageInfo(data.id);
            data.info.image = imageInfo;
            const monochromeAsset = new VistaAsset(data, AssetType.Monochrome, this.authProvider, undefined, this._callbackFunc);
            if (includeSignature) {
                yield monochromeAsset.presign();
            }
            return monochromeAsset;
        });
    }
    /**
     * Return Embroidery variant of the asset.
     */
    getEmbroidery({ includeSignature = true, route = Route.V3 } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (route && !isRoute(route)) {
                throw new Error(`${route} is not a valid route`);
            }
            const data = yield this.getVariantMetadata(this._data, VariantType.Embroidery, route);
            const embroideryAsset = new VistaAsset(data, AssetType.Embroidery, this.authProvider, undefined, this._callbackFunc);
            if (includeSignature) {
                yield embroideryAsset.presign();
            }
            return embroideryAsset;
        });
    }
    /**
     * Hides the asset.
     * @param {Object} signal Object containing an optional abort signal property which is used to cancel method execution in progress.
     * @returns {Promise<Boolean>} Returns true if hide is successful else false.
     */
    hide({ signal, ownerId } = {}) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.isDamAsset()) {
                    const headers = new Headers(yield this.authProvider.getAuthHeaders());
                    yield hideAsset({ path: { id: this._data.id } }, { signal: signal, headers });
                    if ((_a = this.data) === null || _a === void 0 ? void 0 : _a.info.asset) {
                        this.setAssetData(Object.assign(Object.assign({}, this.data), { info: Object.assign(Object.assign({}, this.data.info), { asset: Object.assign(Object.assign({}, this.data.info.asset), { hidden: true }) }) }));
                        return true;
                    }
                }
                else {
                    const headers = yield this.authProvider.getAuthHeaders();
                    yield hideUnhide({
                        uploadId: this._data.id,
                        hide: true,
                        headers: headers,
                        signal: signal,
                        ownerId: ownerId,
                    });
                    if ((_b = this.data) === null || _b === void 0 ? void 0 : _b.info.asset) {
                        this.setAssetData(assetDataFromUMS(Object.assign(Object.assign({}, this.data), { info: Object.assign(Object.assign({}, this.data.info), { asset: Object.assign(Object.assign({}, this.data.info.asset), { hidden: true }) }) })));
                        return true;
                    }
                }
                return false;
            }
            catch (error) {
                throw error.message;
            }
        });
    }
    /**
     * Unhide the asset.
     * @param {Object} signal Object containing an optional abort signal property which is used to cancel method execution in progress.
     * @returns {Promise<Boolean>} Returns true if unhide is successful else false.
     */
    unhide({ signal, ownerId } = {}) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.isDamAsset()) {
                    const headers = new Headers(yield this.authProvider.getAuthHeaders());
                    yield unhideAsset({ path: { id: this._data.id } }, { signal: signal, headers });
                    if ((_a = this.data) === null || _a === void 0 ? void 0 : _a.info.asset) {
                        this.setAssetData(Object.assign(Object.assign({}, this.data), { info: Object.assign(Object.assign({}, this.data.info), { asset: Object.assign(Object.assign({}, this.data.info.asset), { hidden: false }) }) }));
                        return true;
                    }
                }
                else {
                    const headers = yield this.authProvider.getAuthHeaders();
                    yield hideUnhide({
                        uploadId: this._data.id,
                        hide: false,
                        headers: headers,
                        signal: signal,
                        ownerId: ownerId,
                    });
                    if ((_b = this.data) === null || _b === void 0 ? void 0 : _b.info.asset) {
                        this.setAssetData(assetDataFromUMS(Object.assign(Object.assign({}, this.data), { info: Object.assign(Object.assign({}, this.data.info), { asset: Object.assign(Object.assign({}, this.data.info.asset), { hidden: false }) }) })));
                        return true;
                    }
                }
                return false;
            }
            catch (error) {
                throw error.message;
            }
        });
    }
    /**
     * Deletes this asset.
     * @param {Object} signal Object containing an optional abort signal property which is used to cancel method execution in progress.
     * @returns {Promise<void>} Returns an empty Promise object.
     */
    delete({ signal, ownerId } = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            // AbortSingle is not used in deleteAsset() method of asset-sdk
            if (this.status.type === AssetStatusType.Deleting) {
                yield when(() => this.status.type !== AssetStatusType.Deleting);
                return;
            }
            if (this.status.type !== AssetStatusType.Deleted && this.status.type !== AssetStatusType.Unprepared) {
                try {
                    this.setStatus({ type: AssetStatusType.Deleting, isHidden: true });
                    const headers = yield this.authProvider.getAuthHeaders();
                    if (this.isDamAsset()) {
                        yield deleteAsset({ path: { id: this._data.id } }, { headers: new Headers(headers) });
                    }
                    else {
                        yield deleteUpload({
                            headers,
                            uploadId: this._data.id,
                            ownerId,
                            signal,
                        });
                    }
                    this.setStatus({ type: AssetStatusType.Deleted, isHidden: true });
                }
                catch (error) {
                    this.setErrorStatus(error);
                    return;
                }
            }
        });
    }
    /**
     * Get the Page info of the specified page
     * @param {number} pageNo denotes the page no of which metadata is required
     * @param {Object} signal Object containing an optional abort signal property which is used to cancel method execution in progress.
     * @returns {Promise<ImageMetadata>} Returns metadata of the page specified
     */
    getPageImageInfo(_a) {
        var _b, _c, _d, _e, _f, _g;
        var { pageNo } = _a, params = __rest(_a, ["pageNo"]);
        return __awaiter(this, void 0, void 0, function* () {
            const imageMetadata = this._pageImageInfo[pageNo];
            if (imageMetadata !== undefined && imageMetadata !== null && Object.keys(imageMetadata).length !== 0) {
                return imageMetadata;
            }
            if (pageNo < 1) {
                throw new Error(`${pageNo} is not a valid page number`);
            }
            const query = __rest(params, []);
            if (((_b = this._data.info.image) === null || _b === void 0 ? void 0 : _b.format) &&
                isAllowedFormat((_c = this._data.info.image) === null || _c === void 0 ? void 0 : _c.format) &&
                'numPages' in this._data.info.image &&
                ((_d = this._data.info.image) === null || _d === void 0 ? void 0 : _d.numPages) &&
                ((_e = this._data.info.image) === null || _e === void 0 ? void 0 : _e.numPages) < pageNo) {
                throw new Error(`page number must in range: [1-${(_f = this._data.info.image) === null || _f === void 0 ? void 0 : _f.numPages}]`);
            }
            let imageInfo;
            if ((_g = this.data) === null || _g === void 0 ? void 0 : _g.id) {
                imageInfo = (yield getPageImageInfo({ path: { id: this.data.id, pageNum: pageNo }, queryParams: Object.assign({}, query) }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) }));
            }
            else {
                throw new Error('Image info not found');
            }
            this._pageImageInfo[pageNo] = imageInfo.data;
            return imageInfo.data;
        });
    }
    /**
     * Gets the URL for the asset of the appropriate AssetType value, for example Print, Preview, or Original variants.
     * @param {GetUrlParams} ParametersObject used to pass parameters into this function. See type documentation for more detailed information.
     * This indicates whether or not to include the signature from the original so that presign doesn't
     * need to be called seperately.
     * @returns {string} Returns the requested asset URL.
     */
    getUrl({ includeSignature = true, showDeleted = false, includeOriginal = true, pageNum, } = {}) {
        switch (this.assetType) {
            case AssetType.Original:
                return this.getVariantPath('original', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.Print:
                return this.getVariantPath('print', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.WebPreview:
                return this.isDamAsset()
                    ? this.getVariantPath('webPreview', includeSignature, showDeleted, pageNum, includeOriginal)
                    : this.getVariantPath('preview', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.Thumb:
                return this.getVariantPath('thumb', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.Embroidery:
                return this.getVariantPath('embroidery', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.BackgroundKnockout:
                return this.getVariantPath('backgroundRemoved', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.Sharpened:
                return this.getVariantPath('sharpened', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.Monochrome:
                return this.getVariantPath('monochrome', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.ImageInfo:
                return this.getVariantPath('imageInfo', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.Embroiderify:
                return this.getVariantPath('embroiderify', includeSignature, showDeleted, pageNum, includeOriginal);
            case AssetType.InvertColor:
                return this.getVariantPath('invertColor', includeSignature, showDeleted, pageNum, includeOriginal);
            default:
                throw Error(`Unknown asset type --> ${this.assetType}`);
        }
    }
    getVariantPath(variantType, includeSignature, showDeleted, pageNum, includeOriginal) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        // the double replace is to support both legacy uploads and uploads v1
        const url = new URL(this.getUrlInternal());
        if (!this.isDamAsset() &&
            variantType !== VariantType.WebPreview &&
            variantType !== VariantType.Preview &&
            variantType !== VariantType.Print &&
            variantType !== VariantType.Thumb &&
            variantType !== VariantType.Original) {
            throw new Error(`unable to generate ${variantType} variant URL for UMS assets`);
        }
        if ((this._data.info.image === null || this._data.info.image === undefined) &&
            pageNum !== null &&
            pageNum !== undefined) {
            throw new Error('MultiPage variant generation is not applicable');
        }
        if (this.isDamAsset() && includeSignature) {
            url.searchParams.set('signature', this.signature ? this.signature : '');
        }
        if (((_a = this._data.info.image) === null || _a === void 0 ? void 0 : _a.format) &&
            !isAllowedFormat((_b = this._data.info.image) === null || _b === void 0 ? void 0 : _b.format) &&
            pageNum !== null &&
            pageNum !== undefined &&
            pageNum !== 1) {
            throw new Error(`MultiPage variant generation is not applicable for page number: ${pageNum}`);
        }
        if (!this.isDamAsset() && pageNum !== null && pageNum !== undefined && pageNum !== 1) {
            throw new Error('Page wise variant url for UMS is not applicable.');
        }
        if (pageNum !== null &&
            pageNum !== undefined &&
            ((_c = this._data.info.image) === null || _c === void 0 ? void 0 : _c.format) &&
            isAllowedFormat((_d = this._data.info.image) === null || _d === void 0 ? void 0 : _d.format) &&
            variantType !== VariantType.WebPreview &&
            variantType !== VariantType.Preview &&
            variantType !== VariantType.Thumb &&
            variantType !== VariantType.ImageInfo &&
            variantType !== VariantType.Embroiderify &&
            variantType !== VariantType.Embroidery &&
            variantType !== VariantType.Original &&
            variantType !== VariantType.InvertColor) {
            throw new Error(`MultiPage variant generation is not applicable for: ${variantType}`);
        }
        let pathName = url.pathname;
        if (((_e = this._data.info.image) === null || _e === void 0 ? void 0 : _e.format) && isAllowedFormat((_f = this._data.info.image) === null || _f === void 0 ? void 0 : _f.format)) {
            if (variantType !== 'original' &&
                pageNum !== undefined &&
                ((_g = this._data.info.image) === null || _g === void 0 ? void 0 : _g.format) &&
                isAllowedFormat((_h = this._data.info.image) === null || _h === void 0 ? void 0 : _h.format) &&
                'numPages' in this._data.info.image &&
                this._data.info.image.numPages) {
                if (pageNum >= 1 && pageNum <= this._data.info.image.numPages) {
                    pathName += `/page_${pageNum}`;
                }
                else {
                    throw new Error(`page number must be in range: [1-${this._data.info.image.numPages}]`);
                }
            }
        }
        if (this.isDamAsset()) {
            // checking the asset is variant asset or not if asset is variant asset then asset.<variantType>.getUrl() will return variantAssetUrl/<variantType>.
            // if asset is not a variant asset then asset.<variantType>.getUrl() will return originalAssetUrl/<variantType>.
            if ((variantType !== 'original' && !((_k = (_j = this.data) === null || _j === void 0 ? void 0 : _j.info.asset) === null || _k === void 0 ? void 0 : _k.isVariant)) ||
                (((_m = (_l = this.data) === null || _l === void 0 ? void 0 : _l.info.asset) === null || _m === void 0 ? void 0 : _m.isVariant) && variantType !== ((_p = (_o = this.data) === null || _o === void 0 ? void 0 : _o.info.asset) === null || _p === void 0 ? void 0 : _p.variant))) {
                if (variantType === VariantType.ImageInfo) {
                    pathName += '/info/image';
                }
                else {
                    pathName += `/${variantType}`;
                }
            }
        }
        else {
            pathName = url.pathname.replace('original', variantType);
            if (includeOriginal) {
                pathName = pathName.replace('print', variantType);
            }
        }
        url.pathname = pathName;
        const searchParams = url.searchParams;
        const firstQueryParam = searchParams.keys().next().value;
        const signatureValue = searchParams.get('signature');
        if (!signatureValue || signatureValue === '') {
            url.searchParams.delete('signature');
        }
        const showDeletedParam = showDeleted ? 'true' : 'false';
        if (showDeleted) {
            if (firstQueryParam) {
                url.searchParams.append('showDeleted', showDeletedParam);
            }
            else {
                url.searchParams.set('showDeleted', showDeletedParam);
            }
        }
        return url.toString();
    }
    getUrlInternal() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
        let url = '';
        if (this.isDamAsset()) {
            url = SHERBERT_URL;
        }
        if ((_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.info.asset) === null || _b === void 0 ? void 0 : _b.isVariant) {
            const id = this._data.id;
            return `${SHERBERT_V3_BASE_URL}/${id}`;
        }
        if ((_d = (_c = this._data) === null || _c === void 0 ? void 0 : _c.properties) === null || _d === void 0 ? void 0 : _d.url) {
            url = (_e = this._data) === null || _e === void 0 ? void 0 : _e.properties.url;
        }
        else if (((_h = (_g = (_f = this._data) === null || _f === void 0 ? void 0 : _f._links) === null || _g === void 0 ? void 0 : _g.self) === null || _h === void 0 ? void 0 : _h.href) !== undefined && ((_l = (_k = (_j = this._data) === null || _j === void 0 ? void 0 : _j._links) === null || _k === void 0 ? void 0 : _k.self) === null || _l === void 0 ? void 0 : _l.href) !== null) {
            if (((_p = (_o = (_m = this._data) === null || _m === void 0 ? void 0 : _m._links) === null || _o === void 0 ? void 0 : _o.self) === null || _p === void 0 ? void 0 : _p.href.toLowerCase().startsWith(SHERBERT_BASE_URL)) ||
                ((_s = (_r = (_q = this._data) === null || _q === void 0 ? void 0 : _q._links) === null || _r === void 0 ? void 0 : _r.self) === null || _s === void 0 ? void 0 : _s.href.toLowerCase().startsWith(SHERBERT_V3_BASE_URL))) {
                const assetId = fetchAssetIdFromSherbertUrl((_v = (_u = (_t = this._data) === null || _t === void 0 ? void 0 : _t._links) === null || _u === void 0 ? void 0 : _u.self) === null || _v === void 0 ? void 0 : _v.href);
                return `${SHERBERT_V3_BASE_URL}/${assetId}`;
            }
            url = this._data._links.self.href;
        }
        if (url.includes('/metadata')) {
            url = url.replace('/metadata', '');
        }
        return url;
    }
    /**
     * returns variant based on variant type.
     * @param {getVariantParams} params Object holding getVariant parameters for this method call.
     * @returns {Promise<void>} Returns void Promise.Throws an error on getVariant failure .
     */
    getVariant(param) {
        return __awaiter(this, void 0, void 0, function* () {
            const { variant, route } = param;
            if (route !== null && route !== undefined && !isRoute(route)) {
                throw new Error(`${route} is not a valid route`);
            }
            try {
                if (!this._data) {
                    throw new Error('cannot find asset');
                }
                switch (route || Route.V3) {
                    case Route.V2:
                        yield getVariantWithPolling({ path: { id: this._data.id, variant } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) });
                        break;
                    case Route.V3:
                        yield getVariantWithPollingV3({ path: { id: this._data.id, variant } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) });
                        break;
                    default:
                        throw new Error(`${route} is not a valid route`);
                }
            }
            catch (error) {
                throw new Error(`unable to get variant`);
            }
        });
    }
    /**
     * returns page wise variant based on variant type and page number.
     * @param {getMultiPageVariantParams} params Object holding getMultiPageVariantParams parameters for this method call.
     * @returns {Promise<void>} Returns void Promise.Throws an error on  getMultiPageVariant failure.
     */
    getMultiPageVariant(param) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            const { variant, route, pageNum } = param;
            if (((_a = this._data.info.image) === null || _a === void 0 ? void 0 : _a.format) &&
                isAllowedFormat((_b = this._data.info.image) === null || _b === void 0 ? void 0 : _b.format) &&
                'numPages' in this._data.info.image &&
                (pageNum < 1 || pageNum > ((_c = this._data.info.image) === null || _c === void 0 ? void 0 : _c.numPages))) {
                throw new Error(`page number must be in range: [1-${this._data.info.image.numPages}]`);
            }
            if (route !== null && route !== undefined && !isRoute(route)) {
                throw new Error(`${route} is not a valid route`);
            }
            try {
                if (!this._data) {
                    throw new Error('cannot find asset');
                }
                const pageNumber = `page_${pageNum}`;
                switch (route || Route.V3) {
                    case Route.V2:
                        yield getMultiPageVariant({ path: { id: this._data.id, variant, pageNum } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) });
                        break;
                    case Route.V3:
                        yield getMultiPageVariantV3({ path: { id: this._data.id, variant, pageNum: pageNumber } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) });
                        break;
                    default:
                        throw new Error(`${route} is not a valid route`);
                }
            }
            catch (error) {
                throw new Error(`unable to get multi page variant ${error.message}`);
            }
        });
    }
    /**
     * Gets the URL for the stacked variant of the asset of the appropriate variant value.
     * @param {GetStackedVariantUrlParams} denotes the variant to create in sequence and wether to include signature
     * @param {VariantParams} denotes parameters to crop the asset and to get monochrome variant with threshold percentage and hex color code.
     * @returns {string} Returns the requested asset URL.
     */
    getStackedVariantUrlV2({ variant1, variant2, variant3, includeSignature = false, showDeleted = false, pageNum, }, { croppingParams, monochromeColorParams }) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            if (!variant1) {
                throw new Error('variants are not specified');
            }
            let urlPath = `${DEFAULT_SHERBERT_BASE_URL}/${Route.V3}/assets/${this.data.id}`;
            if (pageNum) {
                urlPath += `/page_${pageNum}`;
            }
            const { l, r, t, b } = croppingParams || {};
            const { threshold, color, inverted } = monochromeColorParams || {};
            let cropParams;
            [variant1, variant2, variant3].forEach((variant) => {
                if (!variant)
                    return; // skip if variant is not specified
                switch (variant) {
                    case 'cropped':
                        cropParams = this.getCroppingParams(l, r, t, b);
                        urlPath += `/${variant}${cropParams}`;
                        break;
                    case 'monochrome':
                        urlPath += `/${variant}${this.getMonochromeColorParams(threshold, color, inverted)}`;
                        break;
                    default:
                        urlPath += `/${variant}`;
                        break;
                }
            });
            const url = new URL(urlPath);
            if (includeSignature) {
                url === null || url === void 0 ? void 0 : url.searchParams.set('signature', this.signature ? this.signature : '');
            }
            if (showDeleted) {
                url === null || url === void 0 ? void 0 : url.searchParams.set('showDeleted', 'true');
            }
            if (url) {
                return url.toString();
            }
            throw new Error('cannot generate the url');
        });
    }
    /**
     * Gets the URL for the stacked variant of the asset of the appropriate variant value.
     * @deprecated Use getStackedVariantUrlV2 instead.
     * @param {GetStackedVariantUrlParams} denotes the variant to create in sequence and wether to include signature.
     * @param {GetParametrizedCroppedParams} denotes parameters to crop the asset. Pass null or undefined if not required.
     * @param {MonochromeColorOptionParams} denotes parameters to get monochrome variant with threshold percentage and hex color code. Pass null or undefined if not required.
     * @returns {string} Returns the requested asset URL.
     */
    getStackedVariantUrl({ variant1, variant2, variant3, includeSignature = false, showDeleted = false, pageNum, }, croppingParams, monochromeColorParams) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            if (!variant1) {
                throw new Error('variants are not specified');
            }
            let urlPath = `${DEFAULT_SHERBERT_BASE_URL}/${Route.V3}/assets/${this.data.id}`;
            if (pageNum) {
                urlPath += `/page_${pageNum}`;
            }
            const { l, r, t, b } = croppingParams || {};
            const { threshold, color, inverted } = monochromeColorParams || {};
            let cropParams;
            [variant1, variant2, variant3].forEach((variant) => {
                if (!variant)
                    return; // skip if variant is not specified
                switch (variant) {
                    case 'cropped':
                        cropParams = this.getCroppingParams(l, r, t, b);
                        urlPath += `/${variant}${cropParams}`;
                        break;
                    case 'monochrome':
                        urlPath += `/${variant}${this.getMonochromeColorParams(threshold, color, inverted)}`;
                        break;
                    default:
                        urlPath += `/${variant}`;
                        break;
                }
            });
            const url = new URL(urlPath);
            if (includeSignature) {
                url === null || url === void 0 ? void 0 : url.searchParams.set('signature', this.signature ? this.signature : '');
            }
            if (showDeleted) {
                url === null || url === void 0 ? void 0 : url.searchParams.set('showDeleted', 'true');
            }
            if (url) {
                return url.toString();
            }
            throw new Error('cannot generate the url');
        });
    }
    /**
     * Gets the colors info of the asset specified by id
     * @param {GetColorParams} params Object holding getColorsInfo parameters for this method call.
     */
    getColorInfo(param) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            const { data: colorInfo } = (yield getColorsInfoV3({ path: { id: this.data.id }, queryParams: param }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) }));
            return colorInfo;
        });
    }
    /**
     * Gets the image URL after cropping.
     * @param {GetParametrizedCroppedParams} params Object holding getParameterizedCropping parameters for this method call.
     */
    getParameterizedCropping(param) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            const { l, r, b, t, includeSignature = false, showDeleted = false, pageNum } = param;
            let pathUrl = `${DEFAULT_SHERBERT_BASE_URL}/v3/assets/${this.data.id}`;
            if (pageNum) {
                pathUrl += `/page_${pageNum}`;
            }
            const cropParams = this.getCroppingParams(l, r, t, b);
            pathUrl += `/cropped${cropParams}`;
            const url = new URL(pathUrl);
            if (includeSignature) {
                url.searchParams.set('signature', this.signature ? this.signature : '');
            }
            if (showDeleted) {
                url.searchParams.set('showDeleted', 'true');
            }
            return url.toString();
        });
    }
    /**
     * Gets the extracted logo info of the asset specified by id
     * @param {GetExtractedLogoParams} params Object holding getExtractedLogo parameters for this method call.
     */
    getExtractedLogo(param) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            const { data: extractedLogoInfo } = (yield getExtractedLogoV3({ path: { id: this.data.id }, queryParams: param }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) }));
            return extractedLogoInfo;
        });
    }
    /**
     * Gets the fonts info of the asset specified by id
     * @param {GetFontsParams} params Object holding getFonts parameters for this method call.
     */
    getFonts(param) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            const { data: fontData } = (yield getFontsV3({ path: { id: this.data.id }, queryParams: param }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) }));
            return fontData;
        });
    }
    /**
     * Fetches the latest Asset Info data and update the Asset
     * @returns {void} Returns void promise.
     */
    updateAssetInfo() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            const { data: infoResponseSchema } = yield getAssetInfoV3({ path: { id: this.data.id } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) });
            const updatedAssetData = Object.assign(Object.assign({}, this.data), { info: infoResponseSchema });
            this.setAssetData(updatedAssetData);
        });
    }
    /**
     * Fetch Image info if not present and return Asset with imageInfo.
     * @returns {Promise<VistaAsset>} Returns VistaAsset promise.
     */
    fetchImageInfo() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this.data) {
                if ((_a = this.data.info) === null || _a === void 0 ? void 0 : _a.image) {
                    // the imageInfo for the asset is already present.
                    return this;
                }
                const { data: imageInfo } = yield getImageInfoV3WithPolling({ path: { id: this.data.id } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) });
                const updatedAssetData = Object.assign(Object.assign({}, this.data), { info: Object.assign(Object.assign({}, this.data.info), { image: imageInfo }), isLocallyProcessed: false });
                this.setAssetData(updatedAssetData);
            }
            return this;
        });
    }
    /**
     * Fetches Image Classification data and updates the Asset
     * @returns {Promise<void>} Returns void promise.
     */
    updateAssetClassificationData() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            const { data: classificationData } = (yield getImageClassificationInfoV3({ path: { id: this.data.id } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) }));
            const { classifications } = classificationData;
            if (classifications) {
                const updatedAssetData = Object.assign(Object.assign({}, this.data), { classifications });
                this.setAssetData(updatedAssetData);
            }
        });
    }
    /**
     * Fetches Image Storage data and updates the Asset
     * @returns {Promise<void>} Returns void promise.
     */
    updateAssetStorageData() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            const { data: storageInfo } = (yield getStorageInfoV3({ path: { id: this.data.id } }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) }));
            if (storageInfo) {
                const updatedAssetData = Object.assign(Object.assign({}, this.data), { info: Object.assign(Object.assign({}, this.data.info), { storage: storageInfo }) });
                this.setAssetData(updatedAssetData);
            }
        });
    }
    /**
     * Gets the extracted image info variant of the asset specified by id
     * @param {GetMultiPageImageInfoParams} params Object holding getImageInfoMultiPage parameters for this method call.
     * @returns {Promise<any>} Return MultiPage image info of asset.
     * */
    getMultiPageImageInfo(param) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let { pageNum } = param;
            if (!((_a = this.data) === null || _a === void 0 ? void 0 : _a.id)) {
                throw new Error('asset id not found');
            }
            pageNum = `page_${pageNum}`;
            const { data: multiPageInfo } = (yield getImageInfoMultipageV3({ path: { id: this.data.id, pageNum }, queryParams: param }, { headers: new Headers(yield this.authProvider.getAuthHeaders()) }));
            return multiPageInfo;
        });
    }
    isDamAsset() {
        if (this._data.tenant && Object.keys(TenantCache.tenantCache).length) {
            if (TenantCache.tenantCache[this._data.tenant]) {
                return true;
            }
        }
        if (tenantList.includes(this._data.tenant)) {
            return true;
        }
        return false;
    }
}
__decorate([
    observable
], VistaAsset.prototype, "_data", void 0);
__decorate([
    observable
], VistaAsset.prototype, "status", void 0);
__decorate([
    observable
], VistaAsset.prototype, "_signature", void 0);
__decorate([
    observable
], VistaAsset.prototype, "_callbackFunc", void 0);
__decorate([
    computed
], VistaAsset.prototype, "data", null);
__decorate([
    action.bound
], VistaAsset.prototype, "setAssetData", null);
__decorate([
    computed
], VistaAsset.prototype, "print", null);
__decorate([
    computed
], VistaAsset.prototype, "webPreview", null);
__decorate([
    computed
], VistaAsset.prototype, "thumbnail", null);
__decorate([
    computed
], VistaAsset.prototype, "embroidery", null);
__decorate([
    computed
], VistaAsset.prototype, "monochrome", null);
__decorate([
    computed
], VistaAsset.prototype, "sharpened", null);
__decorate([
    computed
], VistaAsset.prototype, "imageInfo", null);
__decorate([
    computed
], VistaAsset.prototype, "isPresigned", null);
__decorate([
    computed
], VistaAsset.prototype, "embroderify", null);
__decorate([
    computed
], VistaAsset.prototype, "invertColor", null);
__decorate([
    computed
], VistaAsset.prototype, "signature", null);
__decorate([
    action.bound
], VistaAsset.prototype, "setSignature", null);
__decorate([
    action.bound
], VistaAsset.prototype, "setStatus", null);
//# sourceMappingURL=VistaAsset.js.map